import React from "react";
import { connect } from "react-redux";
import {fetchfaciliteiten} from "./Reducers/actions"
import BootstrapTable from "react-bootstrap-table-next";
import { Link } from "react-router-dom";
import paginationFactory from "react-bootstrap-table2-paginator";
import { message } from "../../Reducers/loading/actions";
class InschrijvingPage extends React.Component {
  state = {
    errors: {},
    loading: false
  };

  componentWillMount() {
    this.getvals({});
    //this.getcount({});
  }

  getvals = () => {
    this.props.fetchfaciliteiten().then((data) => {
      if (data.type !== "ACTIVITEIT_ERROR") {
        this.setState({loading: false})
      }
    });
  };


  handleItem(item) {
    this.props.Verwerken({ id: item._id }).then((datav) => {
      this.getvals({});
    });
  }

  render() {
 
    const columns = [
      {
        dataField: "naam",
        text: "Naam faciliteit",
        formatter: (cellContent, row) => {
          if (cellContent.NL) {
            return cellContent.NL
          } else {
            return cellContent
          }
      }
      },
      {
        text: "Toevoegen",
        dataField: "_id",
        formatter: (cellContent, row) => {
          return (
            <span>
               <Link
                className="btn btn-sm btn-warning"
                to={{ pathname: "/faciliteiten/edit/"+row._id}}
              >
                Wijzigen
              </Link>{" "}
              <Link
                className="btn btn-success"
                to={{ pathname: "/faciliteiten/show/"+row._id}}
              >
                Beschikbaarheid invoeren
              </Link>{" "}
              <Link
                className="btn btn-sm btn-info"
                to={{ pathname: "/faciliteiten/reserveringen/"+row._id}}
              >
                Reserveringen
              </Link>
            </span>
          );
        },
        headerStyle: (colum, colIndex) => {
          return { width: "450px" };
        },
      },
    ];
    const { faciliteiten } = this.props;
    return (
      <div className="box box-default">
        <div className="box-header with-border">
          <h3 className="box-title"> Faciliteiten</h3>
          <div className="box-tools pull-right">
            <Link
              type="button"
              className="btn-primary btn btn-box-too btn-sm"
              to="/faciliteiten/insert"
            >
              <i className="fa fa-plus"></i>&nbsp; Faciliteit Toevoegen
            </Link>
          </div>
        </div>
        <div className="box box-default">
          <div className="row">
            <div className="col-md-12 no-float">
              <div className="box box-primary">
                <div className="box-body box-profile" />
                <BootstrapTable
                  wrapperClasses="table-responsive-md"
                  keyField="_id"
                  data={faciliteiten}
                  columns={columns}
                  pagination={paginationFactory()}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    username: state.auth.user,
    faciliteiten: state.faciliteiten.items,
  };
}

export default connect(mapStateToProps, {
  message,
  fetchfaciliteiten
})(InschrijvingPage);
